export default __webpack_public_path__ + "static/media/ChickenFries.c6b1ed31.jpg";